module.exports = __webpack_public_path__ + "media/images/back_to_top-dfcc4d286d0f6ab797f4f3370a064df7.png";